import SelectionLearnTriautoContent from './SelectionLearnTriautoContent';

export default SelectionLearnTriautoContent;
